import { Home, Building2, GraduationCap, Sparkles, Truck, CalendarCheck } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";

const SERVICES = [
  {
    icon: Home,
    title: "Residential Cleaning",
    desc: "Homes, apartments, condos, and regular housekeeping.",
    img: "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjBzcG90bGVzcyUyMGhvbWUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODYzOTYzNjF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Building2,
    title: "Office Cleaning",
    desc: "Professional cleaning for offices and workplaces.",
    img: "https://images.unsplash.com/photo-1715593949273-09009558300a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG9mZmljZSUyMGludGVyaW9yfGVufDB8fHx8MTc4NjM5NjM2Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: GraduationCap,
    title: "School Cleaning",
    desc: "Cleaning services for schools and educational spaces.",
    img: "https://images.unsplash.com/photo-1635424239131-32dc44986b56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3ODYzOTYzNjJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Sparkles,
    title: "Deep Cleaning",
    desc: "Detailed cleaning for areas that need extra attention.",
    img: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=70",
  },
  {
    icon: Truck,
    title: "Move-In / Move-Out Cleaning",
    desc: "Prepare a property for a new tenant, owner, or move.",
    img: "https://images.unsplash.com/photo-1630699376106-d550afb865bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxlbXB0eSUyMGNsZWFuJTIwYXBhcnRtZW50fGVufDB8fHx8MTc4NjM5NjM2MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: CalendarCheck,
    title: "Recurring Cleaning",
    desc: "Weekly, biweekly, or monthly cleaning services.",
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=70",
  },
];

const Services = () => (
  <section id="services" className="bg-[#FAF8FF] py-20 sm:py-24" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        eyebrow="Our Services"
        title="Cleaning Services That Shine"
        subtitle="From cozy apartments to busy offices and schools, we bring the same sparkle to every space."
      />
      <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.1}>
            <article
              className="group h-full overflow-hidden rounded-2xl border border-[#8E7CC3]/15 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/40"
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-7">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#E6E6FA]">
                  <s.icon className="h-5 w-5 text-[#674EA7]" aria-hidden="true" />
                </span>
                <h3 className="mt-5 text-xl font-medium text-[#2C2A35]">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#6B6776]">{s.desc}</p>
                <a
                  href="#quote"
                  data-testid={`service-quote-link-${i}`}
                  className="mt-5 inline-block text-sm font-bold uppercase tracking-wider text-[#8E7CC3] transition-colors hover:text-[#674EA7]"
                >
                  Get a Quote →
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
